<template>
<q-card class="q-mt-lg">
  <q-card-section>
    <h2>Zoekresultaten
      <count-chip :count="totalCount" />
    </h2>
  </q-card-section>
  <q-card-section>
    <q-tabs
        v-model="tab"
        no-caps
        v-if="results.objectGroups.length"
    >
      <q-tab name="rules" label="Richtlijnen" />
      <q-tab name="objects" label="Inrichtingselementen" />
    </q-tabs>

    <template v-if="tab === 'rules'">
      <p v-if="results.groupedRuleVersions.length < 1" class="q-mt-md">
        Er zijn geen resultaten gevonden.</p>
      <expansion-element v-for="(phase,index) in results.groupedRuleVersions"
                         :label="phase.title"
                         :key="phase.id"
                         :items-count="phase.ruleVersions.length"
                         header-tag="h3"
                         group="phases">
        <q-list>
          <RuleResult
              v-for="ruleVersion in phase.ruleVersions"
              :key="`${phase.id}-${ruleVersion.id}`"
              :rule-version="ruleVersion"
              :group="`${ phase.id }-rules`" />
        </q-list>
      </expansion-element>
    </template>
    <template v-else-if="tab === 'objects'">
      <expansion-element v-for="(group,index) in results.objectGroups"
                         :label="group.title"
                         :key="group.id"
                         :items-count="group.objects.length"
                         header-tag="h3"
                         group="objectgroups"
                         :default-opened="index === 0">
        <q-list>
          <ObjectResult
              v-for="object in group.objects"
              :key="object.id"
              :group="`objects-${group.id}`"
              :object="object" />
        </q-list>
      </expansion-element>
    </template>

    <template v-for="(phase,index) in results.groupedRuleVersions"
              :key="phase.id">
      <input v-for="ruleVersion in phase.ruleVersions"
             :key="`${phase.id}-${ruleVersion.id}`"
             type="hidden"
             name="rule_version_ids[]"
             :value="ruleVersion.id">
    </template>
    <template v-for="(group,index) in results.objectGroups"
              :key="group.id">
      <input v-for="object in group.objects"
             :key="object.id"
             type="hidden"
             name="object_ids[]"
             :value="object.id">
    </template>
  </q-card-section>
</q-card>
</template>

<script>
import DocumentList from '~HIOR/components/lists/DocumentList'
import ObjectResult from './partials/ObjectResult'
import RuleResult from './partials/RuleResult'
import { ref } from 'vue'

export default {
  components: {
    DocumentList,
    ObjectResult,
    RuleResult,
  },
  setup () {
    const tab = ref('rules')
    return {
      tab,
    }
  },
  props: {
    results: {
      type: Object,
      required: true,
    },
  },
  computed: {
    totalCount () {
      return this.results.groupedRuleVersions.reduce((amount, phase) => amount + phase.ruleVersions.length, 0)
    },
  },
}
</script>
